module.exports = __webpack_public_path__ + "img/selected6-min.f3ac4381.png";